module.exports = __webpack_public_path__ + "img/trustafrica.de2e031c.png";